"use strict";

angular.module("customer")
.directive("cartItem", function() {
    return {
        restrict: "E",
        controllerAs: "cartItemCtrl",
        templateUrl: require("./cart-item.directive.html"),
        scope: true,
        bindToController: {
            cartItem: "=",
            vendor: "="
        },
        controller: function(
            $scope, CartItemService, StockProductDetailsModalService, PreferredService, StocksService, ModalService,
            CoreProductVariantService, UserService, PRODUCT_TYPES
        ) {
            var _this = this;

            $scope.TABS = StocksService.TABS;
            $scope.activeTab = $scope.TABS.SALES;
            if (_this.cartItem.is_return) {
                $scope.activeTab = $scope.RETURNS;
            }
            else if (_this.cartItem.is_inventory_return) {
                $scope.activeTab = $scope.INVENTORY_RETURNS;
            }
            else if (_this.cartItem.is_custom_discounted_price) {
                $scope.activeTab = $scope.CUSTOM_DISCOUNTS;
            }

            $scope.isReturn = this.cartItem.is_return || this.cartItem.is_inventory_return;
            $scope.isSales = $scope.isCustomerInventoryAvailable = !$scope.isReturn && !this.cartItem.is_custom_discounted_price;
            $scope.isInventoryValidationRequired = $scope.showRebate = !$scope.isReturn;
            $scope.isProductAvailable = (
                this.cartItem.catalog_entry.enabled
                && this.cartItem.catalog_entry.product.enabled
            );

            $scope.isProductVariant = false;
            $scope.isProductVariantAvailable = true;
            $scope.catalogEntryVariant = {};
            $scope.variantOptions = [];
            if (
                _this.vendor.allow_product_variants
                && _this.cartItem.catalog_entry.product.has_variants
                && _this.cartItem.catalog_entry_variant
            ) {
                $scope.isProductVariant = true;
                $scope.catalogEntryVariant = _this.cartItem.catalog_entry_variant;
                $scope.variantOptions = _this.vendor.variant_options;
                $scope.isProductVariantAvailable = (
                    _this.cartItem.catalog_entry_variant.enabled
                    && _this.cartItem.catalog_entry.product.enabled
                )
            }

            UserService.isUserFetched().then(function onSuccess(user) {
                if (!user) {
                    return;
                }
                $scope.hasPermissionOnDistribution = !!(
                    _this.cartItem.catalog_entry.product.product_type !== PRODUCT_TYPES.DISTRIBUTION
                    || (
                        _this.cartItem.catalog_entry.product.product_type === PRODUCT_TYPES.DISTRIBUTION
                        && user.dedicated_vendor_id
                    )
                );
            });

            this.getProductVariantName = function(optionValues) {
                return CoreProductVariantService.getProductVariantName($scope.variantOptions, optionValues);
            };

            this.togglePreferred = function() {
                var catalogEntry = this.cartItem.catalog_entry;
                PreferredService.updateCatalogEntry(catalogEntry).then(function(data) {
                    _this.cartItem.catalog_entry.preferred = data.preferred;
                });
            };

            this.showBestPriceProductDetails = function() {
                var params = {
                    ignoreQuantity: true,
                    vendor: this.vendor,
                    deliveryRules: this.vendor.delivery_rules,
                    productAcquisitionMethod: this.vendor.product_acquisition_method,
                    isOrderTemplate: $scope.isOrderTemplate
                };
                StockProductDetailsModalService.showProductDetails(
                    this.cartItem.catalog_entry.product.best_price_catalog_entry,
                    params
                );
            };

            this.showProductDetails = function() {
                var catalogEntry = this.cartItem.catalog_entry;
                var catalogEntryVariant = this.cartItem.catalog_entry_variant;
                var originalQuantity = this.cartItem.quantity;
                var params = {
                    orderQuantity: this.cartItem.quantity,
                    vendor: this.vendor,
                    activeTab: $scope.activeTab,
                    isVariableMeasure: this.vendor.enable_product_measure_management && catalogEntry.product.is_variable_measure,
                    deliveryRules: this.vendor.delivery_rules,
                    productAcquisitionMethod: this.vendor.product_acquisition_method,
                    catalogEntryVariant: catalogEntryVariant,
                    isOrderTemplate: $scope.isOrderTemplate,
                    closeOnQuantityUpdate: true
                };
                StockProductDetailsModalService.showProductDetails(catalogEntry, params)
                .then(function(result) {
                    catalogEntry.preferred = result.preferred;
                    catalogEntry.product.inventory_product = result.inventoryProduct;

                    var quantity = result.quantity;
                    if (result.catalogEntryVariant) {
                        quantity = result.variantQuantity;
                    }

                    _this.cartItem.quantity = quantity;
                    if (quantity >= 0 && quantity !== originalQuantity) {
                        $scope.$emit("updateCart");
                    }
                });
            };

            this.addProductToCartFromSuggestedValue = function() {
                if ($scope.isProductVariant) {
                    return;
                }
                var quantity = 0;

                var product = this.cartItem.catalog_entry.product;
                if (product.inventory_product.suggested > 0) {
                    quantity = product.inventory_product.suggested;
                }

                var currentQuantity = this.cartItem.quantity;
                this.cartItem.quantity = quantity;

                if (this.isCartItemQuantityValid() && currentQuantity !== quantity) {
                    this.updateCartQuantity(quantity);
                }
            };

            this.isCartItemQuantityValid = function() {
                if ($scope.isProductVariant) {
                    return true;
                }
                if ($scope.isReturn) {
                    return true;
                }
                var catalogEntry = this.cartItem.catalog_entry;
                return CartItemService.isCartItemQuantityValid(
                    catalogEntry.quantity_min,
                    catalogEntry.quantity_max,
                    this.cartItem.quantity
                );
            };

            this.isProductInventoryQuantityValid = function() {
                if ($scope.isReturn) {
                    return true;
                }
                if ($scope.isProductVariant) {
                    return (
                        !this.vendor.is_cart_vendor_exists
                        || !this.vendor.block_order_when_out_of_stock
                        || CartItemService.isProductInventoryQuantityValid(
                            this.cartItem.catalog_entry_variant.inventory_quantity,
                            this.cartItem.quantity
                        )
                    );
                }
                return (
                    !this.vendor.is_cart_vendor_exists
                    || !this.vendor.block_order_when_out_of_stock
                    || CartItemService.isProductInventoryQuantityValid(
                        this.cartItem.catalog_entry.inventory_quantity,
                        this.cartItem.quantity
                    )
                );
            };

            this.getProductInventoryQuantityError = function() {
                if ($scope.isProductVariant) {
                    return CartItemService.getProductInventoryQuantityError(this.cartItem.catalog_entry_variant.inventory_quantity);
                }
                return CartItemService.getProductInventoryQuantityError(this.cartItem.catalog_entry.inventory_quantity);
            };

            this.useVariableMeasure = function(vendor, product) {
                if ($scope.isProductVariant) {
                    return false;
                }
                return (
                    vendor.enable_product_measure_management
                    && product.is_variable_measure
                    && CartItemService.isOnDeliverySelected(vendor)
                );
            }

            this.useReadonlyVariableMeasure = function(vendor, product) {
                if ($scope.isProductVariant) {
                    return false;
                }
                return (
                    vendor.enable_product_measure_management
                    && product.is_variable_measure
                    && !CartItemService.isOnDeliverySelected(vendor)
                );
            }

            this.isProductQuantityChanged = function() {
                return this.cartItem.initial_order_quantity !== this.cartItem.quantity;
            };

            this.isUnitOfMeasureQuantityPatternValid = function() {
                if (!this.vendor.enable_product_measure_management) {
                    return true;
                }

                var catalogEntry = this.cartItem.catalog_entry;
                if (parseFloat(this.cartItem.quantity) === 0) {
                    return true;
                }
                if (catalogEntry) {
                    return CartItemService.isUnitOfMeasureQuantityPatternValid(this.cartItem.total_measure);
                }
            };

            this.getUnitOfMeasureQuantityPatternError = function() {
                return CartItemService.getUnitOfMeasureQuantityPatternError();
            };

            this.isUnitOfMeasureQuantityChanged = function() {
                return this.cartItem.initial_total_measure !== this.cartItem.total_measure;
            };

            this.autoSelect = function($event) {
                $event.stopPropagation();
                return $event.target.select();
            };

            this.saveUnitOfMeasureQuantity = function() {
                var totalMeasure = this.cartItem.total_measure;
                if (parseFloat(totalMeasure) === 0 || this.isUnitOfMeasureQuantityPatternValid()) {
                    var promise;
                    var catalogEntry = this.cartItem.catalog_entry;
                    var catalogEntryVariant = this.cartItem.catalog_entry_variant;

                    if (this.cartItem.is_inventory_return) {
                        promise = CartItemService.saveInventoryReturnUnitOfMeasureQuantity(
                            catalogEntry, catalogEntryVariant, totalMeasure, this.vendor, this.cartItem
                        );
                    }
                    else if (this.cartItem.is_return) {
                        promise = CartItemService.saveReturnUnitOfMeasureQuantity(
                            catalogEntry, catalogEntryVariant, totalMeasure, this.vendor, this.cartItem
                        );
                    }
                    else if (this.cartItem.is_custom_discounted_price) {
                        promise = CartItemService.saveDiscountedUnitOfMeasureQuantity(
                            catalogEntry, catalogEntryVariant, totalMeasure, this.vendor, this.cartItem, catalogEntry.custom_discounted_price
                        );
                    }
                    else {
                        promise = CartItemService.saveOrderedUnitOfMeasureQuantity(
                            catalogEntry, catalogEntryVariant, totalMeasure, this.vendor, this.cartItem
                        );
                    }

                    promise.then(function onSuccess() {
                        $scope.$emit("updateCart");
                    });
                }
            }

            this.setQuantity = function() {
                var catalogEntry = this.cartItem.catalog_entry;
                var catalogEntryVariant = this.cartItem.catalog_entry_variant;
                var originalQuantity = this.cartItem.quantity;
                var quantityMin = catalogEntry.quantity_min;
                var quantityMax = catalogEntry.quantity_max;
                var inventoryQuantity = catalogEntry.inventory_quantity;
                if (catalogEntryVariant) {
                    inventoryQuantity = catalogEntryVariant.inventory_quantity;
                }
                var availableQuantities = catalogEntry.minimal_available_quantities;
                var packagingQuantity = catalogEntry.packaging_quantity;
                var suggestedOrderMultiplier = catalogEntry.product.suggested_order_multiplier;
                var modalParameters = {
                    inputs: {
                        $attrs: {
                            originalQuantity: originalQuantity,
                            inventoryQuantity: inventoryQuantity,
                            quantityMin: quantityMin,
                            quantityMax: quantityMax,
                            packagingQuantity: packagingQuantity,
                            availableQuantities: availableQuantities,
                            suggestedOrderMultiplier: suggestedOrderMultiplier,
                            vendor: this.vendor
                        }
                    }
                }
                var orderedModalParameters = {
                    templateUrl: require("customer/app-core/ordered-quantity/modals/ordered-quantity.modal.html"),
                    controller: "OrderedQuantityModalController",
                    controllerAs: "orderedQuantityCtrl"
                };
                var returnedModalParameters = {
                    templateUrl: require("customer/app-core/ordered-quantity/modals/returned-quantity.modal.html"),
                    controller: "ReturnedQuantityModalController",
                    controllerAs: "returnedQuantityCtrl"
                };

                if ($scope.isReturn) {
                    angular.extend(modalParameters, returnedModalParameters);
                }
                else {
                    angular.extend(modalParameters, orderedModalParameters);
                }

                ModalService.showModal(modalParameters).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function() {
                        modal.element.remove();
                    });
                    modal.close.then(function(quantity) {
                        modal.element.remove();
                        if (quantity >= 0 && quantity !== originalQuantity) {
                            _this.updateCartQuantity(quantity);
                        }
                    });
                });
            };

            this.deleteItem = function() {
                var promise;
                var catalogEntry = this.cartItem.catalog_entry;
                var catalogEntryVariant = this.cartItem.catalog_entry_variant;

                if (this.cartItem.is_inventory_return) {
                    promise = CartItemService.updateInventoryReturnQuantity(
                        this.vendor, 0, catalogEntry, catalogEntryVariant
                    );
                }
                else if (this.cartItem.is_return) {
                    promise = CartItemService.updateReturnQuantity(
                        this.vendor, 0, catalogEntry, catalogEntryVariant
                    );
                }
                else if (this.cartItem.is_custom_discounted_price) {
                    promise = CartItemService.updateDiscountedQuantity(
                        this.vendor, 0, catalogEntry, catalogEntryVariant, catalogEntry.custom_discounted_price
                    );
                }
                else {
                    promise = CartItemService.updateSalesQuantity(
                        this.vendor, 0, catalogEntry, catalogEntryVariant
                    );
                }

                promise.then(function onSuccess() {
                    $scope.$emit("fetchCart");
                });
            };

            this.updateCartQuantity = function(quantity) {
                this.cartItem.quantity = quantity;

                if (_this.isCartItemQuantityValid(this.cartItem) && _this.isProductMultiplierValid()) {
                    var promise;
                    var catalogEntry = this.cartItem.catalog_entry;
                    var catalogEntryVariant = this.cartItem.catalog_entry_variant;

                    if (this.cartItem.is_inventory_return) {
                        promise = CartItemService.updateInventoryReturnQuantity(
                            this.vendor, quantity, catalogEntry, catalogEntryVariant
                        );
                    }
                    else if (this.cartItem.is_return) {
                        promise = CartItemService.updateReturnQuantity(
                            this.vendor, quantity, catalogEntry, catalogEntryVariant
                        );
                    }
                    else if (this.cartItem.is_custom_discounted_price) {
                        promise = CartItemService.updateDiscountedQuantity(
                            this.vendor, quantity, catalogEntry, catalogEntryVariant, catalogEntry.custom_discounted_price
                        );
                    }
                    else {
                        promise = CartItemService.updateSalesQuantity(
                            this.vendor, quantity, catalogEntry, catalogEntryVariant
                        );
                    }

                    promise.then(function(response) {
                        if (response) {
                            _this.cartItem.total_measure = response.total_measure;
                            $scope.$emit("updateCart");
                        }
                    });
                }
                else {
                    var errorElementId = "#error-cart-item";
                    if ($scope.isReturn) {
                        errorElementId = "#error-return-cart-item";
                    }
                    common.scrollTo(errorElementId + this.cartItem.id);
                }
            };

            this.setInventoryQuantity = function() {
                var catalogEntry = this.cartItem.catalog_entry;
                var originalQuantity = catalogEntry.product.inventory_product.inventory_quantity;
                var packagingQuantity = catalogEntry.packaging_quantity;

                ModalService.showModal({
                    templateUrl: require("customer/app-core/inventory/modals/inventory-quantity.modal.html"),
                    controller: "QuantityModalController",
                    controllerAs: "quantityModalCtrl",
                    inputs: {
                        $attrs: {
                            originalQuantity: originalQuantity,
                            packagingQuantity: packagingQuantity
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function() {
                        modal.element.remove();
                    });
                    modal.close.then(function(quantity) {
                        modal.element.remove();
                        if (quantity >= 0 && quantity !== originalQuantity) {
                            _this.updateInventoryQuantity(quantity);
                        }
                    });
                });
            };

            this.updateInventoryQuantity = function(quantity) {
                StocksService.updateInventoryQuantity(this.cartItem.catalog_entry, quantity, this.vendor)
                .then(function(inventory_product) {
                    _this.cartItem.catalog_entry.product.inventory_product.id = inventory_product.id;
                    _this.cartItem.catalog_entry.product.inventory_product.inventory_quantity = inventory_product.inventory_quantity;
                    _this.cartItem.catalog_entry.product.inventory_product.suggested = inventory_product.suggested;
                });
            };

            this.isOutOfStock = function() {
                if (!$scope.isInventoryValidationRequired) {
                    return false;
                }
                if ($scope.isProductVariant) {
                    return this.vendor.is_cart_vendor_exists && StocksService.isProductVariantOutOfStock(this.cartItem.catalog_entry_variant);
                }
                return this.vendor.is_cart_vendor_exists && StocksService.isOutOfStock(this.cartItem.catalog_entry);
            };

            this.isExpectedAvailabilityDateValid = function() {
                var expectedAvailabilityDate = this.cartItem.catalog_entry.product.expected_availability_date;
                return expectedAvailabilityDate && moment(expectedAvailabilityDate).isSameOrAfter(moment());
            };

            this.showAlternativeProductButton = function() {
                if ($scope.isProductVariant) {
                    return false;
                }
                var alternativeProductKeywords = this.cartItem.catalog_entry.product.alternative_product_keywords;
                if (!$scope.isCustomerInventoryAvailable || !alternativeProductKeywords) {
                    return false;
                }
                return this.isOutOfStock();
            };

            this.isButtonDisabled = function() {
                return this.isOutOfStock() && parseFloat(this.cartItem.quantity) === 0;
            };

            this.isProductMultiplierValid = function() {
                if ($scope.isReturn) {
                    return true;
                }

                return CartItemService.isProductMultiplierValid(
                    this.cartItem.catalog_entry.packaging_quantity,
                    this.cartItem.quantity
                );
            };

            this.isInventoryValueChanged = function() {
                if (this.cartItem.catalog_entry.product.inventory_product !== null && this.cartItem.catalog_entry.product.inventory_product !== undefined) {
                    return this.cartItem.initial_inventory_quantity !== this.cartItem.catalog_entry.product.inventory_product.inventory_quantity;
                }
            };

            this.isInventoryValueUnchanged = function() {
                if (this.cartItem.catalog_entry.product.inventory_product !== null && this.cartItem.catalog_entry.product.inventory_product !== undefined) {
                    return this.cartItem.initial_inventory_quantity === this.cartItem.catalog_entry.product.inventory_product.inventory_quantity;
                }
            };

            this.getQuantityMinMaxError = function() {
                if ($scope.isProductVariant) {
                    return true;
                }
                if ($scope.isReturn) {
                    return true;
                }
                var catalogEntry = this.cartItem.catalog_entry;
                if (catalogEntry) {
                    var min = catalogEntry.quantity_min;
                    var max = catalogEntry.quantity_max;
                    return CartItemService.getQuantityMinMaxError(min, max);
                }
            };

            this.getProductMultiplierError = function() {
                return CartItemService.getProductMultiplierError(this.cartItem.catalog_entry.packaging_quantity);
            };

            this.useBestProductPrice = function() {
                var catalogEntry = this.cartItem.catalog_entry;
                var catalogEntryVariant = this.cartItem.catalog_entry_variant;
                var bestPriceCatalogEntry = catalogEntry.product.best_price_catalog_entry;
                var quantity = this.cartItem.quantity;

                CartItemService.updateSalesQuantity(this.vendor, 0, catalogEntry, catalogEntryVariant).then(function() {
                    CartItemService.updateSalesQuantity(_this.vendor, quantity, bestPriceCatalogEntry).then(function() {
                        $scope.$emit("fetchCart");
                    });
                });
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/cart/cart-item.directive.js
// module id = 934
// module chunks = 0